import { MbAccelerator } from '@am/moebius';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

const HIDE_DELAY = 16000;
@Component({
  selector: 'am-few-offer-accelerator',
  templateUrl: './few-offer-accelerator.component.html',
})
export class FewOfferAcceleratorComponent implements OnInit, OnDestroy {
  @Input()
  public occupancy: number;
  @Output()
  public resetOcuppancy: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('accelerator', { static: true }) public accelerator: MbAccelerator;

  constructor() {}

  public ngOnInit() {
    this.acceleratorVisibility();
  }

  public acceleratorVisibility() {
    if (!this.accelerator.isVisible()) {
      this.accelerator.show();
      setTimeout(() => {
        this.accelerator.hide();
      }, HIDE_DELAY);
    }
  }

  public ngOnDestroy() {
    this.resetOcuppancy.emit();
  }
}
